module.exports = __webpack_public_path__ + "static/media/wifi.da36ce7c.svg";